import { Component, OnDestroy, OnInit } from '@angular/core';
import { ContentHeaderComponent } from '../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../shared/components/title/title.component';
import { KompaktGeometergeschaeftComponent } from '../../../shared/kompaktdarstellung/geometergeschaeft/kompakt-geometergeschaeft.component';
import {
  NgbModal,
  NgbNav,
  NgbNavContent,
  NgbNavItem,
  NgbNavItemRole,
  NgbNavLink,
  NgbNavLinkBase,
  NgbNavOutlet
} from '@ng-bootstrap/ng-bootstrap';
import { KopfdatenelementComponent } from '../../../shared/widgets/kopfdatenelement/kopfdatenelement.component';
import { KompaktAvMutationComponent } from '../../../shared/kompaktdarstellung/av-mutation/kompakt-av-mutation.component';
import { StammpersonTableComponent } from '../../../shared/widgets/person/stammperson-table/stammperson-table.component';
import { BeschreibungTableWrapperComponent } from '../../../shared/components/table/beschreibung-table-wrapper.component';
import { ListLoaderWrapperComponent } from '../../../shared/components/list-loader-wrapper/list-loader-wrapper.component';
import { NgTemplateOutlet } from '@angular/common';
import { KompaktGrundbuchgeschaeftComponent } from '../../../shared/kompaktdarstellung/grundbuchgeschaeft/kompakt-grundbuchgeschaeft.component';
import { LinkComponent } from '../../../shared/components/link/link.component';
import { KompaktStammpersonComponent } from '../../../shared/kompaktdarstellung/stammperson/kompakt-stammperson.component';
import { TitleFunctionbarComponent } from '../../../shared/components/title-functionbar/title-functionbar.component';
import {
  GrundstueckListEntryVm,
  GrundstueckSelection,
  GrundstueckTableComponent
} from '../../../shared/widgets/grundstueck-table/grundstueck-table.component';
import { BreadcrumbComponent } from '../../../shared/breadcrumb/breadcrumb.component';
import { CapSpinnerSmallComponent } from '../../../shared/components/cap-spinner-small/cap-spinner-small.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { DatumPipe } from '../../../shared/pipes/simple/datum.pipe';
import { DatumZeitPipe } from '../../../shared/pipes/simple/datumZeit.pipe';
import { AbstractComponent } from '../../../shared/components/abstract-component/abstract.component';
import {
  AvgeometergeschaeftService,
  GeometergeschaeftDetailEntryMeta,
  GeometergeschaeftKopfdatenDetailEntryMeta,
  GeometergeschaeftListEntryMeta
} from '../../../core/av-api';
import { PolitischeGemeindeId, PolitischeGemeindeListEntry, StammdatengemeindeService } from '../../../core/stammdaten-api';
import { ListLoaderObservable } from '../../../shared/components/list-loader/list-loader-observable';
import { PersonStammMasterDetailEntryMeta, PersonstammpersonService } from '../../../core/personstamm-api';
import { ListLoaderPagination, ListLoaderPaginationBuilder } from '../../../shared/components/list-loader/list-loader-pagination';
import { GbGeschaeftId, GbgrundbuchgeschaeftService, GbgrundstueckService, GrundbuchgeschaeftListEntryMeta } from '../../../core/gb-api';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { TimepointService } from '../../../core/services/timepoint.service';
import { KompaktGrundstueckPipe } from '../../../shared/kompaktdarstellung/grundstueck/kompakt-grundstueck.pipe';
import { KompaktGrundstueckbeschreibungPipe } from '../../../shared/kompaktdarstellung/grundstueck-beschreibung/kompakt-grundstueckbeschreibung.pipe';
import { GrundstuecknummerPipe } from '../../../shared/pipes/simple/grundstuecknummer.pipe';
import { DokulinkItemBuilderFactory } from '../../../shared/components/dokulink/dokulinkItemBuilderFactory';
import { GbPrintService } from '../../../core/services/app-print.service';
import { AuszugPrintService } from '../../../shared/components/auszug/auszug-print-service';
import { keysToTranslate } from '../../../../i18n/keys-to-translate';
import { map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { HistoryMode } from '../../../core/services/HistoryMode';
import { PaginationLookupResult } from '../../../shared/components/list-loader/pagination-lookup-result';
import { GrundstueckAuszugSettingsComponent } from '../../../shared/components/auszug/settings/grundstueck-auszug-settings.component';
import VerarbeitungsArtEnum = GeometergeschaeftListEntryMeta.VerarbeitungsArtEnum;
import ProjektMutationTypEnum = GeometergeschaeftListEntryMeta.ProjektMutationTypEnum;

@Component({
  selector: 'cap-geometergeschaeft-detail',
  templateUrl: './geometergeschaeft-detail.component.html',
  styleUrls: ['./geometergeschaeft-detail.component.scss'],
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    KompaktGeometergeschaeftComponent,
    NgbNav,
    NgbNavItem,
    NgbNavItemRole,
    NgbNavLink,
    NgbNavLinkBase,
    NgbNavContent,
    KopfdatenelementComponent,
    KompaktAvMutationComponent,
    StammpersonTableComponent,
    BeschreibungTableWrapperComponent,
    ListLoaderWrapperComponent,
    NgTemplateOutlet,
    KompaktGrundbuchgeschaeftComponent,
    LinkComponent,
    KompaktStammpersonComponent,
    NgbNavOutlet,
    TitleFunctionbarComponent,
    GrundstueckTableComponent,
    BreadcrumbComponent,
    CapSpinnerSmallComponent,
    TranslatePipe,
    DatumPipe,
    DatumZeitPipe
  ]
})
export class GeometergeschaeftDetailComponent extends AbstractComponent implements OnInit, OnDestroy {
  geoGeschaeft: GeometergeschaeftDetailEntryMeta;
  polGemeinde: PolitischeGemeindeListEntry;
  aktenempfaenger: ListLoaderObservable<PersonStammMasterDetailEntryMeta>;
  auftraggeber: ListLoaderObservable<PersonStammMasterDetailEntryMeta>;
  grundbuchgeschaeftAnmelder: Array<PersonStammMasterDetailEntryMeta>;
  beteiligteGrundstueckeLoader: ListLoaderPagination<GrundstueckListEntryVm>;
  listLoaderGbGeschaeft: ListLoaderObservable<GrundbuchgeschaeftListEntryMeta>;

  readonly ID_PARAMETER_NAME = 'id';
  grundstueckIds = [];
  private readonly PAGE_SIZE = 15;
  private readonly CURRENT_PAGE = 1;

  constructor(
    private route: ActivatedRoute,
    private geometergeschaeftService: AvgeometergeschaeftService,
    private timepointService: TimepointService,
    private gemeindeService: StammdatengemeindeService,
    private personstammService: PersonstammpersonService,
    private zeitpunktService: TimepointService,
    private gbgeschaeftService: GbgrundbuchgeschaeftService,
    private grundstueckService: GbgrundstueckService,
    private translate: TranslateService,
    private kompaktGrundstueckPipe: KompaktGrundstueckPipe,
    private kompaktGrundstueckBeschreibung: KompaktGrundstueckbeschreibungPipe,
    private grundstuecknummerPipe: GrundstuecknummerPipe,
    protected dokuLinkBuilderFactory: DokulinkItemBuilderFactory,
    public gbPrintService: GbPrintService,
    private auszugService: AuszugPrintService,
    private modalService: NgbModal
  ) {
    super();
    keysToTranslate<string>([
      'titel.detail.geometergeschaeft',
      'Mutationsart',
      'Verarbeitungsart',
      'AV-Mutationsnummer',
      'BereitFuerGrundbuch',
      'RueckmeldungGrundbuch',
      'AuftraggeberFreitext',
      'AktenempfaengerFreitext',
      'auftraggeber',
      'aktenempfaenger',
      'Ohne',
      'Typ',
      'Geometergeschaeft.detail.VermarkungZurueckgestellt'
    ]);
    keysToTranslate<ProjektMutationTypEnum | VerarbeitungsArtEnum>([
      'PROJEKT',
      'NORMAL',
      'ABSCHLUSS',
      'STANDARD',
      'LANDUMLEGUNG',
      'FLAECHENBERICHTIGUNG',
      'ERSTERHEBUNG_ERNEUERUNG',
      'AV_BEMERKUNG'
    ]);
  }

  ngOnInit() {
    const sub = this.route.paramMap
      .pipe(
        switchMap((params: ParamMap) => {
          const id = params.get(this.ID_PARAMETER_NAME);
          this.timepointService.timepointId = id;
          return this.geometergeschaeftService.loadGeometergeschaeftById(id);
        })
      )
      .subscribe((entry) => {
        this.geoGeschaeft = entry;
        this.loadGemeinde(this.geoGeschaeft.gemeindeId);
        this.loadAuftraggeber(this.geoGeschaeft.kopfdatenDetailEntry);
        this.loadAktenempfaenger(this.geoGeschaeft.kopfdatenDetailEntry);
        if (this.geoGeschaeft.kopfdatenDetailEntry.geschaeftsTyp === 'DEFAULT_MIT_GRUNDBUCH') {
          this.loadGrundbuchgeschaeft(this.geoGeschaeft.grundbuchGeschaeftId);
        } else {
          this.listLoaderGbGeschaeft = new ListLoaderObservable<GrundbuchgeschaeftListEntryMeta>(undefined, 1, of([]));
        }
        this.beteiligteGrundstueckeLoader = this.createBeteiligteGrundstueckeLoader();
      });
    this.subscriptions.push(sub);
  }

  loadGemeinde(gemeindeId: PolitischeGemeindeId) {
    const sub = this.gemeindeService.loadGemeinde(gemeindeId.id).subscribe((g) => (this.polGemeinde = g));
    this.subscriptions.push(sub);
  }

  loadAuftraggeber(kopfdaten: GeometergeschaeftKopfdatenDetailEntryMeta) {
    if (!(kopfdaten && kopfdaten.auftraggeber)) {
      this.auftraggeber = new ListLoaderObservable<PersonStammMasterDetailEntryMeta>(undefined, 1, of([]));
      return;
    }
    const timepointIso = this.zeitpunktService.timepointCtx.timepointIso;
    const sub = this.personstammService
      .loadById(kopfdaten.auftraggeber.id, HistoryMode.HistoryMode.MIT_HIST, null, timepointIso, null)
      .pipe(
        map((person) => {
          return [person];
        })
      );
    this.auftraggeber = new ListLoaderObservable<PersonStammMasterDetailEntryMeta>(undefined, 1, sub);
    this.addLoader(this.auftraggeber);
  }

  loadAktenempfaenger(kopfdaten: GeometergeschaeftKopfdatenDetailEntryMeta) {
    if (!(kopfdaten && kopfdaten.aktenempfaenger)) {
      this.aktenempfaenger = new ListLoaderObservable<PersonStammMasterDetailEntryMeta>(undefined, 1, of([]));
      return;
    }
    const sub = this.personstammService
      .loadById(
        kopfdaten.aktenempfaenger.id,
        HistoryMode.HistoryMode.OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN,
        null,
        this.zeitpunktService.timepointCtx.timepointIso,
        null
      )
      .pipe(
        map((person) => {
          return [person];
        })
      );
    this.aktenempfaenger = new ListLoaderObservable<PersonStammMasterDetailEntryMeta>(undefined, 1, sub);
    this.addLoader(this.aktenempfaenger);
  }

  loadGrundbuchgeschaeft(grundbuchGeschaeftId: GbGeschaeftId) {
    this.grundbuchgeschaeftAnmelder = [];
    if (grundbuchGeschaeftId) {
      const sub = this.gbgeschaeftService.loadGbGeschaeftListEntryById(grundbuchGeschaeftId.id).pipe(
        map((geschaeft) => {
          this.loadPersonStamm(geschaeft);
          return [geschaeft];
        })
      );
      this.listLoaderGbGeschaeft = new ListLoaderObservable<GrundbuchgeschaeftListEntryMeta>(undefined, 1, sub);
      this.addLoader(this.listLoaderGbGeschaeft);
    } else {
      this.listLoaderGbGeschaeft = new ListLoaderObservable<GrundbuchgeschaeftListEntryMeta>(undefined, 1, of([]));
    }
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription?.unsubscribe();
    }
  }

  getZip() {
    this.selectGrundstueckSettings(this.grundstueckIds);
  }

  updateCheckedGrundstueckIdList($event: GrundstueckSelection) {
    this.grundstueckIds = $event.grundstueckIds;
  }

  selectGrundstueckSettings(list) {
    const modalRef = this.modalService.open(GrundstueckAuszugSettingsComponent);
    modalRef.componentInstance.hasToZip = true;
    modalRef.componentInstance.ids = list;
    modalRef.componentInstance.indexNumber = 0;
  }

  private loadPersonStamm(geschaeft) {
    const timepointIso = this.zeitpunktService.timepointCtx.timepointIso;
    for (const anmelderId of geschaeft.anmelderId) {
      const sub = this.personstammService
        .loadById(anmelderId, HistoryMode.HistoryMode.OHNE_HIST, null, timepointIso, null)
        .subscribe((entry) => this.grundbuchgeschaeftAnmelder.push(entry));
      this.subscriptions.push(sub);
    }
  }

  private createBeteiligteGrundstueckeLoader(): ListLoaderPagination<GrundstueckListEntryVm> {
    const observable = (offset, limit, sortColumn) =>
      this.grundstueckService
        .loadGrundstueckSichtByGeschaeftId(
          'GEO',
          this.geoGeschaeft.id.id,
          HistoryMode.HistoryMode.OHNE_HIST,
          offset,
          limit,
          sortColumn.sortDirectionBackend,
          sortColumn.sortEnumBackend
        )
        .pipe(
          map((r) => {
            const grundstueckListEntryVms = r.results.map(
              (e) =>
                new GrundstueckListEntryVm(e, {
                  translate: this.translate,
                  grundstuecknummerPipe: this.grundstuecknummerPipe,
                  kompaktGrundstueckBeschreibung: this.kompaktGrundstueckBeschreibung,
                  kompaktGrundstueckPipe: this.kompaktGrundstueckPipe,
                  dokuLinkBuilderFactory: this.dokuLinkBuilderFactory
                })
            );
            return <PaginationLookupResult<GrundstueckListEntryVm>>{
              result: grundstueckListEntryVms,
              totalItems: r.totalItems
            };
          })
        );

    const loader = ListLoaderPaginationBuilder.builder<GrundstueckListEntryVm>()
      .setLookupItemFunc(observable)
      .setCurrentPage(this.CURRENT_PAGE)
      .setPageSize(this.PAGE_SIZE)
      .build();
    this.addLoader(loader);
    return loader;
  }
}
